// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.size-106 {
  line-height: 106px !important;
  font-size: 40px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/contact-image-displayer/contact-image-displayer.component.scss"],"names":[],"mappings":"AAAA;EACC,6BAAA;EACA,0BAAA;AACD","sourcesContent":[".size-106 {\r\n\tline-height: 106px !important;\r\n\tfont-size: 40px !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
